import React, { MouseEventHandler, useEffect, useState } from 'react';
import { getStarsAndReviews } from 'components/Yotpo/helpers';
import { Rating } from '../../../types/Product';
import { YotpoStarsUI } from 'components/Yotpo/YotpoStars/YotpoStarsUI';

type YotpoStarsProps = {
  rating?: Rating;
  StarComponent?: React.FC<{ type: string }>;
};

const Star: React.FC<{ type: string }> = ({ type }) => {
  switch (type) {
    case 'star':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="#000" xmlns="http://www.w3.org/2000/svg"
             style={{ display: 'inline', verticalAlign: 'middle' }}>
          <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
        </svg>
      );
    case 'half-star':
      return (
        <svg width="19" height="19" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg"
             style={{ display: 'inline', verticalAlign: 'middle' }}>
          <defs>
            <clipPath id="half-clip">
              <rect x="0" y="0" width="12" height="24"/>
            </clipPath>
          </defs>
          <path
            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24
       l-7.19-.61L12 2 9.19 8.63 2 9.24
       l5.46 4.73L5.82 21z"
            fill="none"
            stroke="#000"
            strokeWidth="1"
          />
          <path
            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24
       l-7.19-.61L12 2 9.19 8.63 2 9.24
       l5.46 4.73L5.82 21z"
            fill="#000"
            clipPath="url(#half-clip)"
          />
        </svg>
      );
    case 'empty-star':
    default:
      return (
        <svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
             style={{ display: 'inline', verticalAlign: 'middle' }}>
          <path
            d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
            stroke="#000"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      );
  }
};

const YotpoStars: React.FC<YotpoStarsProps> = ({
  rating,
  StarComponent = Star
}: YotpoStarsProps) => {

  const { score = 0, totalReviews = 0 } = rating;
  const { stars } = getStarsAndReviews(rating, StarComponent);

  const [anchorTarget, setAnchorTarget] = useState(null);

  const handleClick: MouseEventHandler<HTMLAnchorElement> = event => {
    event.preventDefault();
    anchorTarget.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    setAnchorTarget(document.getElementById('yotpo-reviews-anchor'));
  }, []);

  return (
    <YotpoStarsUI
      stars={stars}
      score={score}
      totalReviews={totalReviews}
      handleClick={handleClick}
    />
  );
};

export default YotpoStars;
